import { render, staticRenderFns } from "./AddConsultant.vue?vue&type=template&id=234a41b2"
import script from "./AddConsultant.vue?vue&type=script&lang=js"
export * from "./AddConsultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports